import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { fetchHandshake } from "@/services/handshake";
import { getHomeJson } from "@/services/home";
import { renderHomeSection } from "@/utils/home";
import { useTranslation } from "next-i18next";
import HomeBottomForMobileView from "@/components/home/HomeBottomForMobileView";
import Seo from "@/components/seo";
import { Fragment } from "react";

const HomePage = ({ home = [], isMobile }) => {
  const { t } = useTranslation("home");
  console.log("home", home);
  // const {handshake}           = getCookies()
  // const static_parts          = homeJson.filter((item) => item.key !== "tabs");
  // const tabs_parts            = homeJson.filter((item) => item.key === "tabs");
  // const [allTabs, setAllTabs] = useState([])

  // eslint-disable-next-line no-unused-vars
  // const getAllTabs = useCallback(async ()=>{
  //   const allTabs = await Promise.all([
  //     ...tabs_parts?.map((tab) => getTabsDataV2(handshake, language, tab)),
  //   ]);
  //   setAllTabs(allTabs)
  // }, [])

  // useEffect(() => {
  //   getAllTabs()
  //   console.log("???????????????????????????/")
  // }, [])

  // const home = [
  //   ...(Array.isArray(static_parts) ? static_parts : []),
  //   ...(Array.isArray(allTabs) ? allTabs : []),
  // ].sort((a, b) => +a.position - +b.position);

  return (
    <>
      <Seo />
      {home?.length
        ? home.map((section) => (
            <Fragment key={section?.key + section?.position}>
              {section?.active
                ? renderHomeSection(section.key, section, t, isMobile)
                : null}
            </Fragment>
          ))
        : null}
      <HomeBottomForMobileView />
    </>
  );
};
export default HomePage;

export async function getServerSideProps({ locale, req, res }) {
  const ua = req.headers["user-agent"] || "";
  const isMobile =
    /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(
      ua
    );
  console.log("isMobile", isMobile);
  // get handshake from cookies or generate new handshake
  const handshake = await fetchHandshake({ req, res, locale });

  // get home page structure json
  const { data, error } = await getHomeJson(handshake);
  if (error) {
    return {
      props: {},
    };
  }
  // path of home json data direct
  const homeJson = data?.data ? data?.data : {};
  console.log("homeJson", homeJson);

  const home = [...(Array.isArray(homeJson) ? homeJson : [])].sort(
    (a, b) => +a.position - +b.position
  );

  return {
    props: {
      isMobile,
      home,
      ...(await serverSideTranslations(locale, ["common", "home", "product"])),
    },
  };
}
